import { render, staticRenderFns } from "./DefaultLayoutSidebarItem.vue?vue&type=template&id=bc9fb1ce&scoped=true&"
import script from "./DefaultLayoutSidebarItem.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutSidebarItem.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayoutSidebarItem.vue?vue&type=style&index=0&id=bc9fb1ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9fb1ce",
  null
  
)

export default component.exports